import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchProducts } from "../../actions/gh_market/productsActions";
import { updateProducts } from "../../actions/gh_market/bundlesActions";

export interface ProductInterface {
  id: number;
  bundle_id: number;
  product_id: string;
  value: number;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<ProductInterface>();

const slice = createSlice({
  name: 'products',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchProducts.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.products;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #updateProducts
      .addCase(updateProducts.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.products;
        state.ids = action.payload.ids;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectProductById,
  selectIds: selectProductIds,
  selectEntities: selectProductEntities,
  selectAll: selectAllProducts,
} = adaptor.getSelectors<RootState>(state => state.ghMarket.products);
